export const EmploymentTypeOptions = [
  { label: '', value: '' },
  { label: 'Full Time', value: 'full-time' },
  { label: 'Part Time', value: 'part-time' },
  { label: 'Contract', value: 'contract' },
  { label: 'Internship', value: 'intern' },
  { label: 'Temporary', value: 'temp' }
]
